import { TextFieldModule } from '@angular/cdk/text-field';
import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    ViewChild,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { IMaskModule } from 'angular-imask';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { IMaskConstants } from '../../../../../core/constants/imask';
import { FormInputCellRendererParams } from '../../../../../core/models/grid/form-input-cell-renderer-params';
import { RegExPattern } from '../../../../../core/models/regexp-pattern/regex-pattern';
import { RegexInputDirective } from '../../../../directives/regex-input/regex-input.directive';
import { FormCellRendererBaseComponent } from '../form-cell-renderer-base/form-cell-renderer-base.component';
import { FormInputControlErrorKeys } from './constants/form-input-control-error-keys';

@Component({
    selector: 'app-form-input-cell-renderer',
    imports: [
        TextFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        IMaskModule,
        NgClass,
        RegexInputDirective,
    ],
    providers: [provideNgxMask()],
    templateUrl: './form-input-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./form-input-cell-renderer.component.scss'],
})
export class FormInputCellRendererComponent extends FormCellRendererBaseComponent<FormInputCellRendererParams> {
    // Static is false because the inputElement is conditionally rendered
    @ViewChild('inputElement', { static: false }) inputElement!: ElementRef;

    maskOptions = IMaskConstants;
    regExPattern = RegExPattern;

    readOnly = false;

    agInit(params: FormInputCellRendererParams): void {
        this.params = params;

        if (params.readOnly) {
            this.readOnly = params.readOnly(params);
        }

        this.formControl = params.context.formArray
            .at(params.node.rowIndex)
            .get(params.column?.getColId()) as FormControl;
    }

    showErrorMessage(): boolean {
        return (
            this.formControl.invalid === true &&
            this.formControl.touched === true &&
            this.getErrorMessage() !== ''
        );
    }

    getErrorMessage(): string {
        if (!this.formControl || !this.formControl.errors) {
            return '';
        }

        const errorMessages = Object.keys(this.formControl.errors).map(
            (errorKey) => {
                const errorValue = this.formControl.errors![errorKey];

                if (Object.keys(FormInputControlErrorKeys).includes(errorKey)) {
                    return errorValue;
                }
            },
        );

        return errorMessages
            .filter((message) => message !== undefined)
            .join(', ');
    }

    onFocus(): void {
        if (this.shouldFocus()) {
            this.inputElement.nativeElement.focus();
            this.isFocusedState.set(true);
        }
    }
}
